var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportRecurring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12298",
    "data-name": "Group 12298",
    transform: "translate(0 -246.942)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18136",
    "data-name": "Rectangle 18136",
    width: 80,
    height: 61.191,
    transform: "translate(0 247.442)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\xCDCONE",
    transform: "translate(-395.958 -228.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12691",
    "data-name": "Caminho 12691",
    d: "M420.206,509.1h27.012a2.2,2.2,0,0,0,0-4.284H420.206a2.2,2.2,0,0,0,0,4.284Z",
    transform: "translate(-0.164 -0.199)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12692",
    "data-name": "Caminho 12692",
    d: "M420.485,519.714h26.434a2.142,2.142,0,0,0,0-4.284H420.485a2.142,2.142,0,0,0,0,4.284Z",
    transform: "translate(-0.163 -1.272)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12693",
    "data-name": "Caminho 12693",
    d: "M429.853,544.03H412.306a2.114,2.114,0,0,1-2.112-2.118h0V497.093h14.838a2.116,2.116,0,0,0,2.111-2.118V479.933h27.573a2.253,2.253,0,0,1,2.262,2.118v35.324a2.112,2.112,0,1,0,4.223,0V482.06a6.49,6.49,0,0,0-6.476-6.38h-29.69a2.124,2.124,0,0,0-1.508.629l-16.98,17.158a2.137,2.137,0,0,0-.6,1.512V541.9a6.38,6.38,0,0,0,6.362,6.38h17.529a2.127,2.127,0,1,0,.018-4.253Zm-6.941-61.056v9.865h-9.755Z",
    transform: "translate(0 0)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12783",
    "data-name": "Path 12783",
    d: "M464.141,546.055a14.426,14.426,0,1,0-23.46,1.4,2.226,2.226,0,0,0,3.046.324,2.167,2.167,0,0,0,.325-3.044,10,10,0,0,1-2.235-6.342,10.109,10.109,0,1,1,14.634,9.026,1.3,1.3,0,0,1-.131.056,1.258,1.258,0,0,1,.042-.346l.709-2.889a2.163,2.163,0,0,0-1.591-2.621,2.173,2.173,0,0,0-2.615,1.589L451,550.8a2.153,2.153,0,0,0,1.395,2.563l7.87,2.721a2.18,2.18,0,0,0,.707.118,2.15,2.15,0,0,0,.947-.219,2.315,2.315,0,0,0,1-2.893,2.151,2.151,0,0,0-1.242-1.1l-2.779-.96A14.6,14.6,0,0,0,464.141,546.055Z",
    transform: "translate(-0.391 -0.521)",
    fill: "#2f64f5",
    stroke: "#2f64f5",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportRecurring);
export default __webpack_public_path__ + "static/media/report-recurring.5a38f4fc06207c60c54a33bd79cffbc4.svg";
export { ForwardRef as ReactComponent };